import { render, staticRenderFns } from "./Mask.vue?vue&type=template&id=df1e83ca&scoped=true&"
import script from "./Mask.vue?vue&type=script&lang=ts&"
export * from "./Mask.vue?vue&type=script&lang=ts&"
import style0 from "./Mask.vue?vue&type=style&index=0&id=df1e83ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df1e83ca",
  null
  
)

export default component.exports